import React from "react";
import { useLocation } from "react-router-dom";
import { Layout, Form, Row, Col, Input, Button, Alert } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { requestReset as requestResetPasswordApi } from "../../api/Password";

const { Content } = Layout;

const RequestResetPasswordForm = () => {
  const [formRequestResetPassword] = Form.useForm();
  let [loading, setLoading] = React.useState(false);
  let [success, setSuccess] = React.useState(null);
  let location = useLocation();

  const onFinish = (values) => {
    setLoading(true);
  
    requestResetPasswordApi(values)
      .then((data) => {
        if (!!data.msg) {
          throw new Error(data.msg);
        }

        setTimeout(() => {
          setSuccess(true);
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        setTimeout(() => {
          setSuccess(false);
          setLoading(false);
        }, 1000);
      });
  };

  let alert = null;
  if (location.state !== undefined) {
    const { redirect, expiredLink } = location.state;
    if (!!redirect && !!expiredLink) {
      alert = (
        <Alert
          className="mb-3"
          message="Le lien de réinitialisation de votre mot de passe a expiré"
          type="error"
        />
      );
    }
  }
  if (success === true) {
    alert = (
      <Alert
        className="mb-3"
        message="Un email avec un lien de réinitialisation vient d’être envoyé à cette adresse"
        type="success"
      />
    );
  } else if (success === false) {
    alert = (
      <Alert
        className="mb-3"
        message="Aucun compte n'est associé à cette adresse"
        type="error"
      />
    );
  }

  return (
    <Content>
      { alert }

      <Form
        form={formRequestResetPassword}
        name="request_reset_password"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          className="mb-2"
          name="email"
          rules={[
            {
              required: true,
              message: "L'email ne peut pas être vide",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="email"
          />
        </Form.Item>

        <Row>
          <Col span={24}>
            <Form.Item className="mt-0">
              <a className="login-form-forgot" href="/login" style={{ float: 'right' }}>
                retour à la page de login
              </a>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" loading={loading} htmlType="submit">
            Valider
          </Button>
        </Form.Item>
      </Form>
    </Content>
  );
};

export default RequestResetPasswordForm;
